<template>
  <v-container>
    <v-card
      class="mx-auto"
      max-width="600"
    >
      <v-card
        dark
        flat
        tile
      >
        <v-img
          src="https://cdn.vuetifyjs.com/images/cards/forest.jpg"
          gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
          max-height="200"
        >
          <v-container class="fill-height">
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h1 class="text-center display-1">Programación</h1>
              </v-col>
              <v-col cols="12">
                <h2 class="text-center subtitle-1 text-capitalize">{{daySelected}}</h2>
              </v-col>
            </v-row>
          </v-container>
        </v-img>
        <v-btn
          absolute
          bottom
          right
          fab
          color="secondary"
          class="primary--text"
          @click="dialogSelect=true"
        >
          <v-icon>fas fa-calendar</v-icon>
        </v-btn>
      </v-card>
      <v-card-text class="py-0">
        <v-timeline
          align-top
          dense
        >
          <v-timeline-item
            v-for="item in programas"
            :key="item.id"
            :color="item.color"
            small
          >
            <v-row class="pt-1">
              <v-col cols="12" md="3">
                <strong>{{item.horario}}</strong>
              </v-col>
              <v-col>
                <strong>{{item.nombre}}</strong>
                <div class="caption">{{item.descripcion}}</div>
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogSelect" max-width="300">
      <v-card>
        <v-card-title class="primary white--text">
          Día de la semana
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="daySelected" column class="pa-0">
            <v-radio label="Domingo" value="domingo"></v-radio>
            <v-radio label="Lunes" value="lunes"></v-radio>
            <v-radio label="Martes" value="martes"></v-radio>
            <v-radio label="Miércoles" value="miercoles"></v-radio>
            <v-radio label="Jueves" value="jueves"></v-radio>
            <v-radio label="Viernes" value="viernes"></v-radio>
            <v-radio label="Sábado" value="sabado"></v-radio>
          </v-radio-group>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getDiaSemana } from '../helpers/time'
export default {
  data () {
    return {
      dialogSelect: false,
      daySelected: null,
      diaDisplay: '',
      programas: []
    }
  },
  methods: {
    getProgramacion () {
      this.$http.programas
        .get(`?dia=${this.daySelected}`)
        .then(res => res.data)
        .then(res => {
          this.programas = res.map((item, index) => {
            const color = index % 2 === 0 ? 'primary' : 'secondary'
            return { ...item, color, horario: `${item.inicio} - ${item.fin}` }
          })
        })
    }
  },
  mounted () {
    this.daySelected = getDiaSemana()
  },
  watch: {
    daySelected () {
      this.getProgramacion()
      this.dialogSelect = false
    }
  }
}
</script>
